import { Validator } from '@vista-digital/validator';
import { cdnStandardAssetOptionsValidator } from '../../../validators/cdn-asset-options';
export const defaultOrderPaymentFormCdnOptions = {
    paymentMethodIcon: { width: 130 }
};
export const orderPaymentFormCdnOptionsValidator = Validator.object({
    paymentMethodIcon: cdnStandardAssetOptionsValidator
});
